import { render, staticRenderFns } from "./AuxiliaryViewer.vue?vue&type=template&id=650cd0b3&scoped=true&"
import script from "./AuxiliaryViewer.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryViewer.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryViewer.vue?vue&type=style&index=0&id=650cd0b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650cd0b3",
  null
  
)

export default component.exports